import parkingOta from 'pages/parkingOta'

export default [
  { path: '/parking-ota', name: 'parkingOta', component: parkingOta, meta: {permits: ['super_admin']}},
]
